import { Injectable, inject } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { map, tap, catchError } from 'rxjs/operators';
import { CasesRepository } from '../../../infrastructure/repositories/cases.repository';
import { CasesState } from '../../states/cases.state';
import { LinkCaseCommand } from './link-case.command';
import { LinkCaseResult } from './link-case.result';

/**
 * Link case use case.
 * Links one case to another case.
 */
@Injectable({ providedIn: 'root' })
export class LinkCaseUseCase {
  private readonly _repository = inject(CasesRepository);
  private readonly _state = inject(CasesState);

  public execute(command: LinkCaseCommand): Observable<LinkCaseResult> {
    this._state.setLinkingCase(true);
    this._state.setErrorLinkedCases(null);

    return this._repository.linkCase(command.caseId, command.linkedCaseId, command.linkType).pipe(
      tap(() => {
        this._state.setLinkingCase(false);
      }),
      map(() => ({ success: true })),
      catchError((error) => {
        this._state.setErrorLinkedCases(error.message || 'Failed to link case');
        this._state.setLinkingCase(false);
        return throwError(() => error);
      })
    );
  }
}
